import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  jobScenariosReducer,
  jobsReducer,
  paramsReducer,
  scenarioReducer
} from './../reducers';
import JobHistoryViewComponent
  from './../Components/JobHistoryViewComponent.jsx';
import * as actionItemHelpers from '../helpers/actionItem';

class JobHistoryContainer extends Component {
  static propTypes = {
    jobScenarioMaps: PropTypes.arrayOf(
      PropTypes.shape({
        jobScenario: PropTypes.object,
        jobLink: PropTypes.string,
        jobName: PropTypes.string
      })
    )
  };

  render() {
    return (
      <div>
        <JobHistoryViewComponent
          {...this.props}
        />
      </div>
    );
  }
}

export const mapStateToProps = (state, ownProps) => {
  const jobScenariosByScenarioId =
   jobScenariosReducer.groupJobScenariosByScenarioId(state);
  let jobScenarios = jobScenariosByScenarioId &&
   jobScenariosByScenarioId[ownProps.scenarioId] ?
    jobScenariosByScenarioId[ownProps.scenarioId] : [];
  jobScenarios = jobScenarios.sort((a, b) => (b.job_id - a.job_id));

  const jobScenarioMaps = jobScenarios.map(jobScenario => {
    const scenario = scenarioReducer.getScenarioById(state, jobScenario.scenario_id);
    const job = jobsReducer.getJobById(state, jobScenario.job_id);
    if (!job) {
      return undefined;
    }
    return {
      jobScenario,
      jobLink: actionItemHelpers._getScenarioJobUrl(
        job,
        paramsReducer.paramsByJobIds(state),
        scenarioReducer.getScenariosByDispatcherId(state, scenario.dispatcher)
      ),
      jobNumber: job.number
    };
  }).filter(x => x);

  const props = { jobScenarioMaps };
  return props;
};

export default connect(
  mapStateToProps
)(JobHistoryContainer);


// WEBPACK FOOTER //
// src/Containers/JobHistoryContainer.jsx